/* eslint-disable no-template-curly-in-string */
import * as Yup from 'yup';

Yup.setLocale({
    number: {
        max: 'This value must be less than or equal to ${max}.',
        min: 'This value must be greater than or equal to ${min}.'
    },
    mixed: {
        required: 'This field is required.'
    },
    string: {
        email: 'Incorrect email address format.',
        max:   'This value is too long.',
        min:   'This value is too short.'
    }
});
